import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, className, ...props }) => {
  let IconComponent;
  
  try {
    // Priority: 1. Direct component passed as prop
    // 2. Name string passed (e.g., "Home" for FiHome)
    if (icon) {
      IconComponent = icon;
    } else if (name) {
      const iconName = name.startsWith('Fi') ? name : `Fi${name}`;
      IconComponent = FiIcons[iconName];
    }
  } catch (e) {
    console.warn(`Icon load failed: ${e.message}`);
    IconComponent = FiAlertTriangle;
  }

  // Fallback if component is still null
  if (!IconComponent) {
    return <FiAlertTriangle className={className} {...props} />;
  }

  return React.createElement(IconComponent, { className, ...props });
};

export default SafeIcon;